import { useSEO } from "../lib/useSEO";
import PageHero from "../components/layout/PageHero";

const CONTENT = {
  "privacy-policy": {
    title: "Privacy Policy",
    body: [
      "Suvera Academy respects your privacy. This policy will describe how personal information submitted through this website — such as enquiry and consultation forms — is collected, used and protected.",
      "Information you submit is used to respond to your enquiry and provide the guidance you request. We do not sell personal information to third parties.",
      "The complete privacy policy will be published here once finalised by Suvera Academy.",
    ],
  },
  "terms-and-conditions": {
    title: "Terms & Conditions",
    body: [
      "These terms will govern the use of the Suvera Academy website and the guidance services described on it.",
      "Content on this website is provided for general information and does not constitute a guarantee of admission, scholarship or visa outcomes.",
      "The complete terms and conditions will be published here once finalised by Suvera Academy.",
    ],
  },
  "cookie-policy": {
    title: "Cookie Policy",
    body: [
      "This policy will explain how the Suvera Academy website uses cookies and similar technologies.",
      "The complete cookie policy will be published here once finalised by Suvera Academy.",
    ],
  },
};

export default function Legal({ page }) {
  const c = CONTENT[page];
  useSEO(`${c.title} — Suvera Academy`, `${c.title} for the Suvera Academy website.`);
  return (
    <main data-testid={`legal-${page}`}>
      <PageHero
        eyebrow="Legal"
        title={c.title}
        breadcrumbs={[{ label: "Home", to: "/" }, { label: c.title }]}
      />
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:py-24">
        <div className="space-y-5 text-base leading-relaxed text-slate-600">
          {c.body.map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </section>
    </main>
  );
}
